/* Packages */
import React from 'react';

/* Common */
import { Button, Icon } from '~/components/common';

/* Icons */
import CheckIcon from '~/../symbols/check.svg';

/* Utilities */
import { trans } from '~/utilities';

export default function ConversionFieldHeader({ field, colExtensionClasses }) {
    const { config } = field;
    const { title, intro, tooltip, usps } = config;

    return (
        <>
            <div className={`col col--flow-component-header ${colExtensionClasses}`}>
                {title && (
                    <p className={`flow__header-title`}>
                        {title}
                    </p>
                )}
                {intro && (
                    <p className={`flow__header-intro`}>
                        {intro}
                    </p>
                )}
            </div>
            {tooltip && (
                <div className={`col col--flow-component-header`}>
                    <Button
                        className={'btn--flow-more-info'}
                        theme={'white'}
                        href={tooltip}
                        target={'_blank'}
                        title={trans(`app.flow.more_info`)}
                        iconClassName={'rotate-n45'}
                        textClassName={'ml-2'}
                    />
                </div>
            )}
            {(usps && usps.length > 0) && (
                <div className="row usps gutters-2 gutters-lg-3 mx-0 mt-3">
                    {usps.map((usp, index) => (
                        <div key={index} className="col-12 d-flex">
                            <Icon
                                theme="base"
                                className={`icon--circle-sm flex-shrink-0 icon--with-circle icon--with-circle icon--with-circle-outline-primary`}
                                url={CheckIcon?.url}
                            />
                            <p className="ml-2 ml-lg-3 text--sm">{ usp }</p>
                        </div>
                    ))}
                </div>
            )}
        </>
    );
}
